import * as React from 'react';
import { Box, Button } from "@mui/material";
import FormBox from './building_blocks/FormBox';
import { useContext } from 'react';
import { UserContext } from '../contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import {
  CardElement,
  useElements,
  useStripe
} from '@stripe/react-stripe-js';
import cardsPathTo from '../utils/Api/cardsPathTo';
import SnackbarContext from '../contexts/SnackbarContext';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

const NewCardDialog = (props) => {
  const { onClose, open } = props
  const { openSnackbar } = useContext(SnackbarContext);
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    const cardElement = elements.getElement(CardElement);
    event.preventDefault();
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });
    if (!error) {
      const paymentMethodId = paymentMethod.id;
      cardsPathTo.create({payment_method_id: paymentMethodId}).then(result => {
        openSnackbar("Cartão adicionado com sucesso!", "success");
        // navigate('/payment-methods');
        handleClose(paymentMethod);
      })
    } else {
      console.log('Error creating payment method:', error);
    }
  };

  const handleClose = (paymentMethod = null) => {
    console.log(paymentMethod);
    onClose(paymentMethod);
  };

  return (
    <Dialog onClose={(() => handleClose())} open={open} fullWidth={true} maxWidth="md">
      <DialogTitle>Adicionar cartão</DialogTitle>
      <Box>
        <FormBox display="flex" flexDirection="column">
          <CardElement options={{
            hidePostalCode: true,
            country: 'BR',
            currency: 'BRL',
          }}/>
          <Box mt={2} sx={{display: 'flex', marginLeft: 'auto'}}>
            <Button onClick={handleSubmit} sx={{marginLeft: 'auto'}} variant="contained" type="button">Adicionar cartão</Button>
          </Box>
        </FormBox>
      </Box>
    </Dialog>
  );
};

export default NewCardDialog;
